export var wrap = {
  margin: '2em'
};